// extracted by mini-css-extract-plugin
export default {"container":"MM-z","title":"NM-z","link":"OM-z"};